/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import { messages } from './messages';
export var BetaTag = function BetaTag() {
  return /*#__PURE__*/React.createElement(Lozenge, {
    style: {
      backgroundColor: "var(--ds-background-neutral, #091E420F)",
      color: "var(--ds-text-subtle, #44546F)"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.beta));
};